import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AgeVerificationPopup = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const hasAccepted = sessionStorage.getItem('ageVerified');
        if (!hasAccepted) {
            setShowPopup(true);
            document.body.style.overflow = 'hidden'; // ✅ Prevent background scroll
        }
        return () => {
            document.body.style.overflow = 'auto'; // Restore scroll
        };
    }, []);

    const handleAccept = () => {
        sessionStorage.setItem('ageVerified', 'true');
        setShowPopup(false);
        document.body.style.overflow = 'auto';
        toast.success('Welcome! Enjoy responsibly 🍷', {
            position: 'top-center',
        });
    };

    const handleDecline = () => {
        toast.error('You must be 18+ to access this site.', {
            position: 'top-center',
        });
        // ❌ No redirection, keep modal open
    };

    if (!showPopup) return null;

    return (
        <div
            className={`
                fixed inset-0 z-[1000] flex items-center justify-center 
                bg-black bg-opacity-60 
                ${/* 🔘 Enable optional backdrop blur */ false ? 'backdrop-blur-sm' : ''}
            `}
        >
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm text-center animate-fade-in-up">
                <h2 className="text-xl font-bold text-[--primary-wine] mb-4">Age Verification</h2>
                <p className="text-[--neutral-gray] mb-6">
                    This site is for adults only. You must be 18 years of age or older to enter.
                </p>
                <div className="flex justify-center gap-4">
                    <button
                        onClick={handleAccept}
                        className="bg-[--primary-wine] hover:bg-[--primary-wine-dark] text-white px-4 py-2 rounded-full transition"
                    >
                        Yes, I am 18+
                    </button>
                    <button
                        onClick={handleDecline}
                        className="bg-[--neutral-light-gray] hover:bg-[--neutral-gray] text-[--neutral-black] px-4 py-2 rounded-full transition"
                    >
                        No, I am not
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AgeVerificationPopup;
